@if (service.progress | async; as p) {
  <mat-card class="progress-card" appearance="outlined">
    <mat-card-content>
      <div class="card-head">
        <div class="card-title">
          <mat-icon>build</mat-icon>
          <span>{{ 'watson.batchRepair.importingTitle' | translate }}</span>
        </div>
        <span class="status-badge" [attr.data-status]="p.failed ? 'error' : 'running'">
          {{ (p.failed ? 'watson.batchRepair.status.error' : 'watson.batchRepair.status.running') | translate }}
        </span>
      </div>
      <p class="progress-label">
        @if (p.failed) {
          {{ 'watson.batchRepair.errors.importFailed' | translate: { count: p.issues } }}
        } @else {
          {{ 'watson.batchRepair.importingProgress' | translate: { current: p.current, total: p.total, issues: p.issues } }}
        }
      </p>
      <div class="progress-bar-row">
        <mat-progress-bar mode="determinate" [value]="percentage(p)"></mat-progress-bar>
        <span class="progress-pct">{{ percentage(p) }}%</span>
      </div>
      @if (p.failed) {
        <div class="card-actions">
          <button mat-button (click)="service.closeOverlay()">{{ 'commons.btn.close' | translate }}</button>
        </div>
      }
    </mat-card-content>
  </mat-card>
}
